export const throttle = <T>(func: (arg: T) => void, delay: number) => {
  let timeoutId: NodeJS.Timeout | null;
  return (...args: [T]) => {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        func(...args);
        timeoutId = null;
      }, delay);
    }
  };
};
